import { AeonyxWordmark } from "./Logo";
import { Phone, EnvelopeSimple, MapPin, ArrowUp, Shield } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";

export default function Footer() {
  const { isAdmin } = useAuth();
  const backToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#081321] text-white/80 pt-24 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="rounded-3xl bg-white p-8 shadow-lg text-navy-deep">
            <AeonyxWordmark
              className="h-[72px] w-auto select-none"
              priority
            />
          </div>

          <div>
            <div className="text-white font-display font-bold text-lg">Quick Links</div>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a href="#featured" className="hover:text-teal-brand transition-colors">Products</a></li>
              <li><a href="#featured" className="hover:text-teal-brand transition-colors">Peptides</a></li>
              <li><a href="#stacks" className="hover:text-teal-brand transition-colors">Stacks</a></li>
              <li><a href="#quality" className="hover:text-teal-brand transition-colors">Quality Control</a></li>
              <li><a href="#faq" className="hover:text-teal-brand transition-colors">FAQ</a></li>
            </ul>
          </div>

          <div>
            <div className="text-white font-display font-bold text-lg">Contact</div>
            <ul className="mt-5 space-y-3.5 text-sm">
              <li className="flex items-center gap-3">
                <span className="h-8 w-8 rounded-full bg-white/5 border border-white/10 grid place-items-center text-teal-brand">
                  <Phone size={14} weight="regular" />
                </span>
                <span className="font-mono-data text-[13px]" data-testid="footer-phone">[PHONE]</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="h-8 w-8 rounded-full bg-white/5 border border-white/10 grid place-items-center text-teal-brand">
                  <EnvelopeSimple size={14} weight="regular" />
                </span>
                <span className="font-mono-data text-[13px]" data-testid="footer-email">[EMAIL]</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="h-8 w-8 rounded-full bg-white/5 border border-white/10 grid place-items-center text-teal-brand">
                  <MapPin size={14} weight="regular" />
                </span>
                <span className="font-mono-data text-[13px]" data-testid="footer-address">[ADDRESS]</span>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-white font-display font-bold text-lg">Legal</div>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a href="/privacy" className="hover:text-teal-brand transition-colors">Privacy Policy</a></li>
              <li><a href="/terms" className="hover:text-teal-brand transition-colors">Terms &amp; Conditions</a></li>
              <li><a href="#" className="hover:text-teal-brand transition-colors">Shipping &amp; Payment</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
          <div className="font-mono-data text-[12px] text-white/50">
            © {new Date().getFullYear()} Aeonyx Life Sciences. All Rights Reserved.
          </div>
          <div className="flex items-center gap-3">
            {isAdmin && (
              <Link
                to="/admin/dashboard"
                data-testid="footer-admin-dashboard"
                className="inline-flex items-center gap-2 rounded-full bg-amber-400/15 hover:bg-amber-400/25 border border-amber-400/40 px-5 h-11 text-sm text-amber-200 transition-colors"
                title="Admin Dashboard"
              >
                <Shield size={14} weight="fill" /> Admin Dashboard
              </Link>
            )}
            <button
              data-testid="back-to-top"
              onClick={backToTop}
              className="inline-flex items-center gap-2 rounded-full bg-white/5 hover:bg-white/10 border border-white/15 px-5 h-11 text-sm text-white transition-colors"
            >
              <ArrowUp size={14} weight="bold" /> Back to top
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
